import clsx from 'clsx';
import React from 'react';
import classes from './LoadingIndicatorSmall.module.scss';

export interface Props {
  className?: string;
  ariaLabel?: string;
}

const LoadingIndicatorSmall: React.FC<Props> = ({ className, ariaLabel = 'Loading' }) => {
  return (
    <div className={clsx(classes.wrapper, className)}>
      <span className={classes.spinner} role="status" aria-label={ariaLabel} />
    </div>
  );
};

export default LoadingIndicatorSmall;
